import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { ProductReview, ProductReviewPayload } from "@core/types";
import { productsClient } from "@core/clients";

type Options = UseMutationOptions<ProductReview, unknown, ProductReviewPayload, string[]>;

const useAddProductReviewMutation = (options?: Options) => {
  return useMutation(
    ["product-reviews", "add"],
    async (productReviewPayload) => {
      return productsClient.addProductReview(productReviewPayload);
    },
    { ...options }
  );
};

export default useAddProductReviewMutation;
